import $ from 'jquery';

const response = () =>{
  let deviceStatus = null;
  function responseBackground(device){
    if(deviceStatus !== device){
      deviceStatus = device;
      $(`[data-${device}]`).each((key,item) =>{
        const image = $(item).data(device);

        $(item).css('background-image',`url( ${image} )`);
      });
    }
  }
  const responseSettings =() =>{
    const windowWidth = window.innerWidth;

    
    if(windowWidth >=740){
      responseBackground('desktop')
    }else{
      responseBackground('mobile')
    }
  }
  responseSettings()
  $(window).resize(responseSettings);
  
  $(document).on('click','.nav-item .title', function openNav(){
    const parent = $(this).parents('.nav-item');

    $('.nav-item').not(parent).removeClass('active');
    parent.toggleClass('active');
  });
}

export default response;
